import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, publishReplay, refCount } from 'rxjs/operators';

import { RpcService } from '../http/rpc.service';
import { Version } from '../version/version';
import { ServerInfo } from './model/serverinfo.model';
import { TokenService } from '../../authentication/token.service';

@Injectable()
export class ServerService {
  private _serverInfo$: Observable<ServerInfo>;

  constructor(private rpc: RpcService, private tokenService: TokenService) {
    this.tokenService.tokenChanged$.subscribe(() => {
      this._serverInfo$ = null;
    });
  }

  public hasAllowedServerVersion(version: Version): Observable<boolean> {
    return this.getServerInfoCall().pipe(
      map((serverInfo: ServerInfo) => {
        if (serverInfo != null) {
          if (serverInfo.hasLiteserver) {
            return serverInfo.liteServerVersion.isGreaterOrEqualThen(version);
          } else {
            return serverInfo.cloudVersion.isGreaterOrEqualThen(version);
          }
        }
      })
    );
  }

  private getServerInfoCall(
    forceReload: boolean = false
  ): Observable<ServerInfo> {
    if (!this._serverInfo$ || forceReload) {
      this._serverInfo$ = this.rpc.makeManagerCall('getServerInfo').pipe(
        map(ServerInfo.fromDTO),
        publishReplay(1),
        refCount()
      );
    }
    return this._serverInfo$;
  }
}
